import { useEffect } from 'react'
import { SUPPORTED_LOCALES } from '@/i18n'

export function useDocumentTitle(title: string) {
  useEffect(() => {
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
}

export function useHreflang(canonicalPathWithoutLocale: string) {
  useEffect(() => {
    const head = document.head
    const existing = head.querySelectorAll('link[data-hreflang="ode"]')
    existing.forEach((el) => el.remove())

    SUPPORTED_LOCALES.forEach((l) => {
      const link = document.createElement('link')
      link.rel = 'alternate'
      link.hreflang = l
      link.href =
        l === 'en'
          ? canonicalPathWithoutLocale
          : `/${l}${canonicalPathWithoutLocale}`
      link.dataset.hreflang = 'ode'
      head.appendChild(link)
    })

    const xDefault = document.createElement('link')
    xDefault.rel = 'alternate'
    xDefault.hreflang = 'x-default'
    xDefault.href = canonicalPathWithoutLocale
    xDefault.dataset.hreflang = 'ode'
    head.appendChild(xDefault)

    return () => {
      const cleanup = head.querySelectorAll('link[data-hreflang="ode"]')
      cleanup.forEach((el) => el.remove())
    }
  }, [canonicalPathWithoutLocale])
}
